import React from "react";

const SubtitleAndDescription = (props) => {
  const { subtitle, description, className, fontSize } = props;

  return (
    <div className={`subtitle-and-description ${className ?? ""}`}>
      <div className="subtitle" style={{ fontSize: fontSize ?? "14px" }}>
        {subtitle}
      </div>
      {description ? <div className="description">{description}</div> : null}
    </div>
  );
};

export default SubtitleAndDescription;
